import * as c from './types';

import { Machine, MachineResponse } from '@models/machine';

import { HistoricalData } from '@models/historical';
import { RealTimeData } from '@models/realtime';
import { createImmerReducer } from '../../reducers/utils/createReducer';

type Status = 'idle' | 'loading' | 'success' | 'error';

interface DashboardDataById {
  [x: number]: {
    status: Status;
    realTimeData?: RealTimeData;
    historicalData?: HistoricalData;
    error: any;
  };
}

interface DashboardState {
  dashboardDataById: DashboardDataById;
  machines: {
    status: Status;
    data: Machine[];
    error?: any;
  };
  timezone: string;
}

const initialState: DashboardState = {
  machines: {
    status: 'idle',
    data: [],
    error: undefined
  },
  dashboardDataById: {},
  timezone: 'Etc/UTC'
};

export default createImmerReducer(initialState, {
  [c.GET_DASHBOARD_REQUEST]: (draft: DashboardState, { payload }) => {
    const { id } = payload;
    draft.dashboardDataById[id as number] = {
      status: 'loading',
      error: undefined
    };
  },
  [c.GET_DASHBOARD_SUCCESS]: (
    draft: DashboardState,
    { payload }: { payload?: MachineResponse }
  ) => {
    if (!payload) return;
    const { historicalData = [] } = payload;

    for (const machineData of historicalData) {
      draft.dashboardDataById[machineData.id].historicalData = machineData;
      //maybe realtime data is empty
      draft.dashboardDataById[machineData.id].status = 'success';
      draft.dashboardDataById[machineData.id].error = undefined;
    }
  },
  [c.GET_DASHBOARD_ERROR]: (draft: DashboardState, { payload }) => {
    const { params, error } = payload;
    const { id } = params;
    draft.dashboardDataById[id] = { status: 'error', error };
  },
  [c.GET_DASHBOARD_MACHINES_REQUEST]: (draft: DashboardState) => {
    draft.machines = { status: 'loading', error: undefined, data: [] };
  },
  [c.GET_DASHBOARD_MACHINES_SUCCESS]: (
    draft: DashboardState,
    { payload }: { payload?: MachineResponse }
  ) => {
    if (!payload) return;
    const { machines } = payload;
    draft.machines = { data: machines, status: 'success' };
    draft.timezone = payload.timezone;
  },
  [c.GET_DASHBOARD_MACHINES_ERROR]: (draft: DashboardState, { payload }) => {
    draft.machines = { data: [], error: payload, status: 'error' };
  }
});
